import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export interface ExportDocumentsData {
  id: string
  title: string
}

export const exportDocumentsAtom = createPrimitiveAtom<
  Record<string, ExportDocumentsData>
  >({})

export async function updateExportDocumentsAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getExportDocuments()
  const record = indexBy(x => x.id, data)
  dispatch(exportDocumentsAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}

